
    import React from 'react';
    import { dynamic } from 'dumi';
    import { Link, AnchorLink, context } from 'dumi/theme';
    import Previewer from 'dumi-theme-mobile/es/builtins/Previewer.js';
import Alert from 'dumi-theme-default/es/builtins/Alert';
import API from 'dumi-theme-default/es/builtins/API';
import Badge from 'dumi-theme-default/es/builtins/Badge';
import Example from 'dumi-theme-default/es/builtins/Example';
import SourceCode from 'dumi-theme-default/es/builtins/SourceCode';
import Tree from 'dumi-theme-default/es/builtins/Tree';
import Table from 'dumi-theme-default/es/builtins/Table';

    // memo for page content, to avoid useless re-render since other context fields changed
    const PageContent = React.memo(({ demos: DUMI_ALL_DEMOS }) => {
      const DumiDemo1 = DUMI_ALL_DEMOS['modal-demo'].component

      return (
        <>
          
          <React.Fragment><div className="markdown"><h1 id="modal-模态框"><AnchorLink to="#modal-模态框" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>Modal 模态框</h1>
<p>弹出模态框，常用于消息提示、消息确认，或在当前页面内完成特定的交互操作。</p>
<p>弹出框组件支持函数调用和组件调用两种方式</p>
</div><Previewer {...DUMI_ALL_DEMOS['modal-demo'].previewerProps}><DumiDemo1 /></Previewer>
<div className="markdown"><h2 id="方法"><AnchorLink to="#方法" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>方法</h2>



































<Table><thead><tr><th>方法名</th><th>说明</th><th>参数</th><th>返回值</th></tr></thead><tbody><tr><td>Modal</td><td>弹窗组件</td><td>options</td><td>React.ReactNode</td></tr><tr><td>Modal.show</td><td>展示提示弹窗</td><td>options</td><td>Promise</td></tr><tr><td>Modal.alert</td><td>展示消息提示弹窗</td><td>options</td><td>Promise</td></tr><tr><td>Modal.confirm</td><td>展示消息确认弹窗</td><td>options</td><td>Promise</td></tr></tbody></Table>
<h2 id="api-props"><AnchorLink to="#api-props" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>API Props</h2>

































































































































































<Table><thead><tr><th>参数</th><th>说明</th><th>类型</th><th>默认值</th></tr></thead><tbody><tr><td>visible</td><td>是否显示弹窗</td><td>boolean</td><td>-</td></tr><tr><td>title</td><td>标题</td><td>string</td><td>-</td></tr><tr><td>width</td><td>弹窗宽度，默认单位为 px</td><td><code>number/string</code></td><td>-</td></tr><tr><td>message</td><td>文本内容，支持通过<code>\n</code> 换行</td><td>React.ReactNode</td><td>-</td></tr><tr><td>messageAlign</td><td>内容对齐方式，可选值为<code>left</code> <code>right</code></td><td>string</td><td><code>center</code></td></tr><tr><td>showConfirmButton</td><td>是否展示确认按钮</td><td>boolean</td><td><code>true</code></td></tr><tr><td>showCancelButton</td><td>是否展示取消按钮</td><td>boolean</td><td><code>false</code></td></tr><tr><td>confirmButtonText</td><td>确认按钮文案</td><td>string</td><td><code>确认</code></td></tr><tr><td>confirmButtonColor</td><td>确认按钮颜色</td><td>string</td><td><code>#3264c8</code></td></tr><tr><td>cancelButtonText</td><td>取消按钮文案</td><td>string</td><td><code>取消</code></td></tr><tr><td>cancelButtonColor</td><td>取消按钮颜色</td><td>string</td><td><code>black</code></td></tr><tr><td>overlay</td><td>是否展示遮罩层</td><td>boolean</td><td><code>true</code></td></tr><tr><td>overlayClass</td><td>自定义遮罩层类名</td><td>string</td><td>-</td></tr><tr><td>overlayStyle</td><td>自定义遮罩层样式</td><td>object</td><td>-</td></tr><tr><td>closeable</td><td>是否展示关闭图标</td><td>boolean</td><td><code>false</code></td></tr><tr><td>closeOnPopstate</td><td>是否在页面回退时自动关闭</td><td>boolean</td><td><code>true</code></td></tr><tr><td>closeOnClickOverlay</td><td>是否在点击遮罩层后关闭弹窗</td><td>boolean</td><td><code>false</code></td></tr><tr><td>lockScroll</td><td>是否锁定背景滚动</td><td>boolean</td><td><code>true</code></td></tr><tr><td>onCancel</td><td>点击取消按钮时触发</td><td>Function</td><td>-</td></tr><tr><td>onConfirm</td><td>点击确认按钮时触发</td><td>Function</td><td>-</td></tr><tr><td>onClose</td><td>Modal 关闭时的回调</td><td>Function</td><td>-</td></tr><tr><td>onClosed</td><td>Modal 完全关闭时的回调</td><td>Function</td><td>-</td></tr><tr><td>teleport</td><td>指定挂载的节点</td><td><code>HTMLElement/() =&gt; HTMLElement</code></td><td><code>body</code></td></tr><tr><td>footer</td><td>自定义底部按钮区域</td><td>ReactNode</td><td>-</td></tr><tr><td>children</td><td>自定义内容</td><td>ReactNode</td><td>-</td></tr></tbody></Table></div></React.Fragment>
        </>
      );
    })

    export default (props) => {
      const { demos } = React.useContext(context);

      // scroll to anchor after page component loaded
      React.useEffect(() => {
        if (props?.location?.hash) {
          AnchorLink.scrollToAnchor(decodeURIComponent(props.location.hash.slice(1)));
        }
      }, []);

      return <PageContent demos={demos} />;
  }